import * as Icons from "@nova/component-icons"
import { ContextMenuItem } from "features/data-management/workspace/TODO-put-in-package/ContextMenu"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { LayerPluginSpec } from "plugins/plugin-registry"
import { removeLayerFromSelection, selectSelectedLayerIds, setRenamingLayerId } from "../slice.new"
import { useMapActions, useMoveActions } from "./genericContextMenuSections"
import {
    getGenericConfirmationModalComponent,
    useConfirmationModalContext,
} from "features/modals/WorkspaceConfirmationModalV2"
import { useArchiveContextMenuOption } from "./useArchiveContextMenuOption"
import { useIsEditor } from "tools/hooks/useIsEditor"
import { SidePanelLayerOrGroup } from "@nova/constants"

export function getUseLayersContextMenuSections(spec: LayerPluginSpec) {
    return function useLayersContextMenuSections(
        id: string,
        sortedEntities: SidePanelLayerOrGroup[]
    ) {
        const dispatch = useAppDispatch()
        const entity = useAppSelector(spec.selectSingleEntity(id))
        const confirmationModal = useConfirmationModalContext()
        const selectedLayerIds = useAppSelector(selectSelectedLayerIds)
        const actions = [] as ContextMenuItem[][]
        const isEditor = useIsEditor()
        if (isEditor) {
            actions.push([
                {
                    title: "Rename",
                    onClick: () => {
                        dispatch(setRenamingLayerId({ id }))
                    },
                    Icon: Icons.Pencil,
                },
            ])
        }
        const mapActions = useMapActions({
            spec,
            id,
        })
        actions.push(mapActions)
        const moveActions = useMoveActions({
            spec,
            id,
            mode: "Layers",
            sortedEntities,
        })
        if (moveActions.length) {
            actions.push(moveActions)
        }
        const archiveAction = useArchiveContextMenuOption(id)
        if (archiveAction) {
            actions.push([archiveAction])
        }
        if (isEditor) {
            actions.push([
                {
                    title: "Delete",
                    onClick: async () => {
                        if (spec.confirmDelete(entity)) {
                            const didConfirm = await confirmationModal.confirm({
                                RenderComponent: getGenericConfirmationModalComponent({
                                    title: "Delete Selection?",
                                    message: `This will delete ${entity.name}, do you want to proceed?`,
                                }),
                            })
                            if (!didConfirm) return
                        }
                        dispatch(spec.deleteAction({ id }))
                        if (selectedLayerIds.includes(id)) {
                            dispatch(removeLayerFromSelection({ id }))
                        }
                    },
                    Icon: Icons.Trash,
                    isDestructive: true,
                },
            ])
        }
        return actions
    }
}
